var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsoleControl9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.87 23.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.21,14.51,13.73,20V6a1,1,0,0,0-2,0V20L6.25,14.51a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L12,23.11a1,1,0,0,0,1.09.22.83.83,0,0,0,.33-.22l7.18-7.18a1,1,0,0,0,0-1.42A1,1,0,0,0,19.21,14.51Z",
    fill: "#5d5b53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.87,0H1A1,1,0,0,0,1,2H23.87a1,1,0,0,0,0-2Z",
    fill: "#5d5b53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoleControl9);
export default __webpack_public_path__ + "static/media/console-control-9.a2d7eb079536b43c1548cf1782338d9c.svg";
export { ForwardRef as ReactComponent };